import React from 'react'

const SvgAngleDoubleRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.294 7.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5.001a1 1 0 11-1.415-1.414L15.587 12l-4.293-4.293zm-5 0a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5.001a1 1 0 01-1.415-1.414L10.587 12 6.294 7.707z'
    />
  </svg>
)

export default SvgAngleDoubleRight
